import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useOrderSummary(params) {
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/orders/summary`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderSummary;
